var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebhook4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_443_8608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H49V49H0V0Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.153125 0H0V0.153125H0.153125V0Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 32.1562H13.7812V33.6875H35.2188V32.1562ZM35.2188 33.6875H13.7812V35.2188H35.2188V33.6875ZM35.2188 35.2188H13.7812V36.75H35.2188V35.2188ZM35.2188 36.75H13.7812V38.2812H35.2188V36.75ZM16.8438 38.2812H13.7812V39.8125H16.8438V38.2812ZM35.2188 38.2812H18.375V39.8125H35.2188V38.2812ZM16.8438 39.8125H13.7812V41.3438H16.8438V39.8125ZM35.2188 39.8125H18.375V41.3438H35.2188V39.8125ZM16.8438 41.3438H13.7812V42.875H16.8438V41.3438ZM35.2188 41.3438H18.375V42.875H35.2188V41.3438ZM16.8438 42.875H13.7812V44.4062H16.8438V42.875ZM35.2188 42.875H18.375V44.4062H35.2188V42.875ZM16.8438 44.4062H13.7812V45.9375H16.8438V44.4062ZM35.2188 44.4062H18.375V45.9375H35.2188V44.4062ZM16.8438 45.9375H13.7812V47.4688H16.8438V45.9375ZM35.2188 45.9375H18.375V47.4688H35.2188V45.9375ZM16.8438 47.4688H13.7812V49H16.8438V47.4688ZM35.2188 47.4688H18.375V49H35.2188V47.4688Z",
    fill: "#1F1D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 32.1562H18.375V33.6875H19.9062V32.1562ZM30.625 32.1562H29.0938V33.6875H30.625V32.1562ZM21.4375 33.6875H19.9062V35.2188H21.4375V33.6875ZM29.0938 33.6875H27.5625V35.2188H29.0938V33.6875ZM22.9688 35.2188H21.4375V36.75H22.9688V35.2188ZM27.5625 35.2188H26.0312V36.75H27.5625V35.2188ZM26.0312 36.75H22.9688V38.2812H26.0312V36.75Z",
    fill: "#FFC110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 38.2812H19.9062V39.8125H29.0938V38.2812Z",
    fill: "#FFF671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 39.8125H19.9062V41.3438H26.0312V39.8125Z",
    fill: "#FFC110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 39.8125H26.0312V41.3438H29.0938V39.8125Z",
    fill: "#FFF671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 41.3438H19.9062V42.875H26.0312V41.3438Z",
    fill: "#FFC110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 41.3438H26.0312V42.875H29.0938V41.3438Z",
    fill: "#FFF671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 4.59375H10.7188V6.125H13.7812V4.59375ZM36.75 4.59375H33.6875V6.125H36.75V4.59375ZM16.8438 6.125H10.7188V7.65625H16.8438V6.125ZM36.75 6.125H30.625V7.65625H36.75V6.125ZM12.25 7.65625H10.7188V9.1875H12.25V7.65625Z",
    fill: "#1F1D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 7.65625H12.25V9.1875H13.7812V7.65625Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 7.65625H13.7812V9.1875H19.9062V7.65625ZM33.6875 7.65625H27.5625V9.1875H33.6875V7.65625Z",
    fill: "#1F1D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 7.65625H33.6875V9.1875H35.2188V7.65625Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 7.65625H35.2188V9.1875H36.75V7.65625ZM12.25 9.1875H10.7188V10.7188H12.25V9.1875Z",
    fill: "#1F1D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8438 9.1875H12.25V10.7188H16.8438V9.1875Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 9.1875H16.8438V10.7188H19.9062V9.1875ZM30.625 9.1875H27.5625V10.7188H30.625V9.1875Z",
    fill: "#1F1D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 9.1875H30.625V10.7188H35.2188V9.1875Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 9.1875H35.2188V10.7188H36.75V9.1875ZM12.25 10.7188H10.7188V12.25H12.25V10.7188Z",
    fill: "#1F1D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.375 10.7188H12.25V12.25H18.375V10.7188Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 10.7188H18.375V12.25H29.0938V10.7188Z",
    fill: "#1F1D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 10.7188H29.0938V12.25H35.2188V10.7188Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 10.7188H35.2188V12.25H36.75V10.7188ZM12.25 12.25H10.7188V13.7812H12.25V12.25Z",
    fill: "#1F1D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8438 12.25H12.25V13.7812H16.8438V12.25Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 12.25H16.8438V13.7812H30.625V12.25Z",
    fill: "#1F1D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 12.25H30.625V13.7812H35.2188V12.25Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 12.25H35.2188V13.7812H36.75V12.25ZM12.25 13.7812H10.7188V15.3125H12.25V13.7812Z",
    fill: "#1F1D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 13.7812H12.25V15.3125H13.7812V13.7812Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 13.7812H13.7812V15.3125H33.6875V13.7812Z",
    fill: "#1F1D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 13.7812H33.6875V15.3125H35.2188V13.7812Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 13.7812H35.2188V15.3125H36.75V13.7812ZM36.75 15.3125H10.7188V16.8438H36.75V15.3125ZM36.75 16.8438H12.25V18.375H36.75V16.8438ZM36.75 18.375H12.25V19.9062H36.75V18.375ZM36.75 19.9062H12.25V21.4375H36.75V19.9062ZM36.75 21.4375H12.25V22.9688H36.75V21.4375ZM36.75 22.9688H12.25V24.5H36.75V22.9688ZM36.75 24.5H12.25V26.0312H36.75V24.5Z",
    fill: "#1F1D29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8438 26.0312H9.1875V27.5625H16.8438V26.0312Z",
    fill: "#7CC4F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 26.0312H16.8438V27.5625H24.5V26.0312Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 26.0312H24.5V27.5625H27.5625V26.0312Z",
    fill: "#FA6FE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 26.0312H27.5625V27.5625H33.6875V26.0312Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8125 26.0312H33.6875V27.5625H39.8125V26.0312Z",
    fill: "#7CC4F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 27.5625H12.25V29.0938H24.5V27.5625Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 27.5625H24.5V29.0938H26.0312V27.5625Z",
    fill: "#5A6B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 27.5625H26.0312V29.0938H36.75V27.5625Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8438 29.0938H9.1875V30.625H16.8438V29.0938Z",
    fill: "#7CC4F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4375 29.0938H16.8438V30.625H21.4375V29.0938Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 29.0938H21.4375V30.625H27.5625V29.0938Z",
    fill: "#5A6B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 29.0938H27.5625V30.625H33.6875V29.0938Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8125 29.0938H33.6875V30.625H39.8125V29.0938Z",
    fill: "#7CC4F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 30.625H12.25V32.1562H36.75V30.625Z",
    fill: "#CAEFF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16.8438H15.3125V18.375H24.5V16.8438ZM35.2188 16.8438H26.0312V18.375H35.2188V16.8438ZM16.8438 18.375H15.3125V19.9062H16.8438V18.375Z",
    fill: "#D19A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 18.375H16.8438V19.9062H19.9062V18.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 18.375H19.9062V19.9062H22.9688V18.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 18.375H22.9688V19.9062H24.5V18.375ZM27.5625 18.375H26.0312V19.9062H27.5625V18.375Z",
    fill: "#D19A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 18.375H27.5625V19.9062H30.625V18.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 18.375H30.625V19.9062H33.6875V18.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 18.375H33.6875V19.9062H35.2188V18.375ZM16.8438 19.9062H10.7188V21.4375H16.8438V19.9062Z",
    fill: "#D19A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 19.9062H16.8438V21.4375H19.9062V19.9062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 19.9062H19.9062V21.4375H22.9688V19.9062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 19.9062H22.9688V21.4375H27.5625V19.9062Z",
    fill: "#D19A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 19.9062H27.5625V21.4375H30.625V19.9062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 19.9062H30.625V21.4375H33.6875V19.9062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 19.9062H33.6875V21.4375H35.2188V19.9062ZM12.25 21.4375H10.7188V22.9688H12.25V21.4375ZM16.8438 21.4375H15.3125V22.9688H16.8438V21.4375Z",
    fill: "#D19A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 21.4375H16.8438V22.9688H19.9062V21.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 21.4375H19.9062V22.9688H22.9688V21.4375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 21.4375H22.9688V22.9688H24.5V21.4375ZM27.5625 21.4375H26.0312V22.9688H27.5625V21.4375Z",
    fill: "#D19A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 21.4375H27.5625V22.9688H30.625V21.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 21.4375H30.625V22.9688H33.6875V21.4375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 21.4375H33.6875V22.9688H35.2188V21.4375ZM12.25 22.9688H10.7188V24.5H12.25V22.9688ZM16.8438 22.9688H15.3125V24.5H16.8438V22.9688Z",
    fill: "#D19A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 22.9688H16.8438V24.5H19.9062V22.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 22.9688H19.9062V24.5H22.9688V22.9688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 22.9688H22.9688V24.5H24.5V22.9688ZM27.5625 22.9688H26.0312V24.5H27.5625V22.9688Z",
    fill: "#D19A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 22.9688H27.5625V24.5H30.625V22.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 22.9688H30.625V24.5H33.6875V22.9688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 22.9688H33.6875V24.5H35.2188V22.9688ZM24.5 24.5H15.3125V26.0312H24.5V24.5ZM35.2188 24.5H26.0312V26.0312H35.2188V24.5Z",
    fill: "#D19A54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_443_8608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebhook4);
export default __webpack_public_path__ + "static/media/webhook4.d4e49b00cc78aa19fd1ec1866f93f29e.svg";
export { ForwardRef as ReactComponent };